import React, { useEffect, useState } from 'react';

import ComboBox from '../../../../../components/ComboBox';
import CollapsableSection from '../../../../../components/CollapsibleSection';
import ButtonForm from '../../../../../components/ButtonForm';
import InputForm from '../../../../../components/InputForm';
import WidgetHeaderStyleFields from '../../../../../components/WidgetHeaderStyleFields';
import SelectableList from '../../../../../components/SelectableList';

import CheckIco from '../../../../../components/icons/CheckIco';
import SelectionForm from '../../../../../components/SelectionForm';
import TrashIco from '../../../../../components/icons/TrashIco';
import Spinner from '../../../../../components/Spinner';
import { useProcesses } from '../../../../../providers/ProcessesContext';
import { getAllParameters } from '../../../../../services/apiProcessParameteres';
import { useAppContext } from '../../../../../providers/AppContext';
import { useAuth } from '../../../../../providers/AuthContext';
import { useNavigate } from 'react-router-dom';
import { getFormattedDates, translateDatePicker } from '../../../../utils';
import { useWidgets } from '../../../../../providers/WidgetContext';
import { useDashboards } from '../../../../../providers/DashboardContext';
import { createWidget, updateWidget } from '../../../../../services/apiWidgests';
import { getWidgetById } from '../../../../../services/apiWidgests';

const ColumnField = ({ header, onChange, onDelete }) => {
  return (
    <div className='flex justify-between items-center w-full mr-3'>
      <div className='flex basis-1/3 items-center gap-1'>
        <input
          className='w-10 h-6'
          type="color"
          value={header.color}
          onClick={(e) => e.stopPropagation()}  // <-- evita que abra el colapsable
          onChange={event => onChange(event.target.value)}
        />
        <span>{header.alias || header.key}</span>
      </div>
      <span className='basis-1/3 text-gray-400'>{header.key}</span>
      <button
        onClick={(e) => {
          e.stopPropagation(); // <-- evita que abra el colapsable
          onDelete?.();
        }}
      >
        <TrashIco fill='red' />
      </button>
    </div>
  );
};


function RegistersTableForm({onSubmit = () => {}, id}) {
  const {auth} = useAuth();
  const {addToast} = useAppContext();
  const navigate = useNavigate();
  const { addCard, assignSpace } = useWidgets();
  const { dashboard , selectedTab} = useDashboards();

  const [processList, setProcessList] = useState([]);
  const [conf, setConf] = useState();
  const [showHeaderStyle, setShowHeaderStyle] = useState(false);
  const {menuItems} = useProcesses();
  const [stage,setStage] = useState("form");
  const [selectedProcess, setSelectedProcess] = useState();
  const [dateOptions, setDateOptions] = useState(getFormattedDates(new Date()));
  const [parameters, setParameters] = useState();
  const [timeVariable, setTimeVariable] = useState("createdAt");
  const [dataRange, setDataRange] = useState('Asignar por dashboard');
  const [title, setTitle] = useState('');
  const [validate, setValidate] = useState(false);

  const [variableTimeOptions, setVariableTimeOptions] = useState(
    {"createdAt": "Fecha de creación"}
  )

  //backend flags
  const [loading, setLoading] = useState(true);
  const [fetchingWidgetInfo, setFetchingWidgetInfo] = useState(true);
  const [fetchingParameters, setFetchingParameters] = useState(true);
  const [creatingWidget, setCreatingWidget] = useState(false);

  //obtener info existente del widget
  const refreshWidgetInfo = () => {
    async function fetchWigdet(){
      const widget = await getWidgetById(id, auth?.token);
      return widget; 
    }
    try {
      setFetchingWidgetInfo(true);
      fetchWigdet().then(response => {
        console.log(response.configuration)
        setConf(response.configuration)
        setSelectedProcess(response.configuration.process.id)
        setTimeVariable(response.configuration.timeVariable)
        setFetchingWidgetInfo(false);
        setTitle(response.title)
      }).catch(error => {
        if (error.response.status === 404){
          console.log("Widget no encontrado")
        }
        else if (error.response.status === 500){
          console.log("Error en el servidor, intente nuevamente")
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error,typeof(error));
      setFetchingWidgetInfo(false);
    }
  }
  
  const refreshParameters = () => {
    async function fetchParameters(){
      const parameters = await getAllParameters(selectedProcess, auth?.token);
      return parameters;
    }
    try {
      setFetchingParameters(true);
      fetchParameters().then(response => {
        console.log(console.log(response))
        let timeVars = {}
        setParameters(response.map(parameter => {
          //añadir variables de tiempo a la lista
          if (parameter.datatype === "date"){
            timeVars[parameter.key] = parameter.alias || parameter.key
          }
          return {
            key: parameter.key,
            alias: parameter.alias,
            type: parameter.datatype
          }
        }));
        setVariableTimeOptions({
          "createdAt": "Fecha de creación",
          ...timeVars
        })
        setFetchingParameters(false);
      }).catch(error => {
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setFetchingParameters(false);
    }
  }

  const createWidgetDB = () => {
    async function fetchWidget(){
      const position= assignSpace();
      const widget = await createWidget({
        type: "processTable",
        title: title,
        description: "",
        configuration: conf,
        dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200,
        selectedTab,
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      fetchWidget().then(response => {
        console.log(console.log(response));
        addCard (
          response._id,
          response.title,
          response.type,
          response.dashboardId,
          
        )
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " creado exitosamente.",1);
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }

  const editWidgetDB = () => {
    async function saveWidget(){

      const widget = await updateWidget(id,{
        type: "processTable",
        title: title,
        description: "",
        configuration: conf,
        /* dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200, */
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      saveWidget().then(response => {
        console.log(console.log(response));
        
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " editado exitosamente.",1);
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }
  //Interacciones con el dashboard
  const selectColums = (selectedItems) => {
    let tempConf = {...conf}
    console.log(tempConf, "antes")
    let newHeaders = parameters.filter( element => {return selectedItems.includes( element.alias || element.key)});
    newHeaders = newHeaders.map(header => {return {...header, displayName: header.alias || header.key, color: "bluesens", stacked: false}})
    tempConf.headers = newHeaders
    setConf(tempConf);
    
  }
  const changeColors = (color, index) => {
    let tempConf = {...conf}
    tempConf.headers[index].color = color
    setConf(tempConf);
    console.log(tempConf)
  }
  const handleDataRangeChange = (selectedRange) => {
    setDataRange(translateDatePicker(selectedRange));
    let tempConf = {...conf}
    tempConf.dateRange = selectedRange
    setConf({...tempConf})
  }
  const handleProcessChange = (selectedProcess) => {
    let tempConf = {...conf}
    tempConf.headers = [];
    tempConf.process = {
      id: selectedProcess,
      name: processList[selectedProcess]
    }
    setConf({...tempConf})
  }
  const handleDecimalsChange = (decimals) => {
    let tempConf = {...conf}
    tempConf.nDecimals = decimals
    setConf({...tempConf})
  }
  const handleChangeWidgetName = (name) => {
    setTitle(name)
  }
  const handleDateFormatChange = (dateFormat) => {
    let tempConf = {...conf}
    tempConf.dateFormat = dateFormat;
    setConf({...tempConf});
  }

  const handleTimeVariableChange = (selectedTimeVar) => {
    setTimeVariable(selectedTimeVar);
    let tempConf = {...conf}
    tempConf.timeVariable = selectedTimeVar
    setConf({...tempConf})
  }
  const handleCreateWidget = () =>{
    //createCard("processTable",title, conf, dashboard._id);
    createWidgetDB();
  }

  const handleEditWidget = () =>{
    //createCard("processTable",title, conf, dashboard._id);
    editWidgetDB();
  }

  useEffect( () => {
    if (stage === "form"){
      
    }
    if (stage === "columnSection"){

    }
  }, [stage]);

  useEffect( () => {
    /*
    {
       process: { name: "Recepción MP", id: 2 },
      headers: [
        { key: "batch", displayName: "Lote", alias: "Lote", color: "bluesens", stacked: true },
        { key: "op", displayName: "Orden Prod.", alias: "OP", color: "bluesens", stacked: true },
        { key: "mp", displayName: "Materia Prima", alias: "MP", type: "dictarray", color: "bluesens" },
        { key: "weight", displayName: "Total", alias: "Peso", type: "numeric", color: "bluesens", stacked: true },
        { key: "date", displayName: "Fecha", alias: "Fecha", type: "date", color: "bluesens" },
      ],
      sortHeader: { "date": false },
      rowsNumber: 10 
    }*/

    const bdConf = {
       process: undefined,
      headers: [
      ],
      sortHeader: {},
      rowsNumber: 10,
      dateRange: {
        "activeTab": "customDates",
        "selectedRange": "byDashboard"
      },
      nDecimals: 2,
      timeVariable: "createdAt",
      dateFormat: "mm/dd/yy - hh:mm"
    }

    setLoading(true);
    //cargar campos
    //cargar conf
    let processOptions = {}
    menuItems.slice(1).map(element => 
      processOptions[element.id] = element.label
    )
    console.log(processOptions);
    if(id) {
      refreshWidgetInfo()
    }
    else{
      setConf(bdConf);
      
    }
    setProcessList(processOptions);
    setLoading(false);
  }, []);

  useEffect( () => {
    if (selectedProcess){
      //limpiar headers actuales
      
      //cargar los parametros
      refreshParameters();
      //actualizar la configuracion
      handleProcessChange(selectedProcess);

    }
  }, [selectedProcess]);

  useEffect( () => {
    if (
      title === "" ||
      !conf?.process ||
      (conf?.headers.length === 0 ) ||
      !conf?.dateRange ||
      !conf?.timeVariable ||
      !conf?.nDecimals
    ){
      setValidate(false);
    }
    else {
      setValidate(true);
    }
  }, [conf, title])

  useEffect( () => {
      if (id){
        refreshWidgetInfo()
      }
      setFetchingWidgetInfo(false)
      
    }, [id])
  return (
    <>
     {stage === "form" && (
      <>
        {conf && !fetchingWidgetInfo && (
            <div className='flex flex-col gap-2 h-[35rem] relative overflow-auto'>
            <div className=' flex flex-col flex-grow gap-2'>
              <CollapsableSection title={"Datos"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' open={true} border={false}>
                <div className='flex flex-col gap-2'>
                  <div className='flex justify-between items-center'>
                    <div className='w-[45%]'>
                      <SelectionForm
                        text="Proceso" 
                        options={Object.keys(processList)} 
                        mask={processList} 
                        value={selectedProcess}
                        onChange={event => setSelectedProcess(event)}
                        AppendClassName='-mb-5'
                        error={!!selectedProcess && !fetchingParameters && parameters.length === 0 ? 'El proceso no tiene parametros creados' : ""}
                      /> 
                    </div>
                    <div className='relative flex '>
                      <ButtonForm text={"Añadir columnas"} enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0} action={()=> setStage("columnSection")} loading={fetchingParameters && selectedProcess}/>
                      <span className='absolute text-sm text-wrap'></span>
                    </div>
                    
                  </div>
                  {conf.headers.map((header, index) => (
                    <CollapsableSection
                      key={index}
                      CustomTitleBar={() => (
                        <ColumnField
                          header={header}
                          onChange={(color) => changeColors(color,index)}
                          onDelete={() => {
                            // eliminar columna
                            const temp = [...conf.headers];
                            temp.splice(index, 1);
                            setConf({...conf, headers: temp});
                          }}
                        />
                      )}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                    >
                      <div className='w-full flex flex-col px-4'>
                        <InputForm text={"Nombre de la columna"} value={header.displayName} />
                        <SelectionForm text="Color" options={["Asignar por widget"]} />
                      </div>
                    </CollapsableSection>
                  ))}
                  <div className='-mb-5 pt-4'>
                    <InputForm 
                      type={"datarange"} 
                      text={"Rango de tiempo"} 
                      value={dataRange} 
                      AppendClassName='text-left' 
                      onChange={(event) => handleDataRangeChange(event)}
                      dateRangeOptions={conf.dateRange}
                      addedRanges={ {"byDashboard": () => {}}} 
                    />
                    
                  </div>
                  <div className='-mb-5 '>
                      <SelectionForm
                        text="Variable de tiempo" 
                        options={Object.keys(variableTimeOptions)} 
                        mask={variableTimeOptions}
                        value={conf.timeVariable || timeVariable}
                        onChange={event => handleTimeVariableChange(event)}
                        AppendClassName=''
                        error={!!selectedProcess && !fetchingParameters && parameters.length === 0 ? 'El proceso no tiene variables de tiempo' : ""}
                      /> 
                    </div>
                </div>
              </CollapsableSection>
              <CollapsableSection title={"Apariencia"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' border={false} open={true}>
                <InputForm text={"Nombre"} value={title} onChange={(event) => setTitle(event.target.value)}/>
                <InputForm type={"number"} text={"Decimales"} value={conf.nDecimals} onChange={(event) => handleDecimalsChange(event.target.value)}/>
                <SelectionForm 
                  text="Formato de fecha" 
                  options={Object.keys(dateOptions)} 
                  mask={dateOptions} 
                  value={conf.dateFormat}
                  onChange={event => handleDateFormatChange(event)} />
                <InputForm type={"button"} text={"Estilo"} value={"Modificar estilo"} AppendClassName='text-left' onClick={() => setShowHeaderStyle(prev => !prev)} />
                {showHeaderStyle && (
                  <div className="pt-2">
                    <WidgetHeaderStyleFields
                      headerColor={conf?.headerColor}
                      headerTextColor={conf?.headerTextColor}
                      onChange={(field, val) => setConf(prev => ({ ...prev, [field]: val }))}
                    />
                  </div>
                )}
              </CollapsableSection>
            </div>

            {/* Span fijo al final del contenedor */}
            <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
              <div className='flex w-full justify-end'>
                  <button className='' onClick={() => id ? handleEditWidget() : handleCreateWidget()} disabled={!validate}>
                    <CheckIco width='50px' height='50px' fill={validate ? 'bluesens': 'gray'}/>
                  </button>
              </div>
            </div>
          </div>
        )}
        {(!conf || fetchingWidgetInfo) && (
          <Spinner />
        )}
      </>
      
      
     )}
     {stage === "columnSection" && (
      <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
        <div className=' flex flex-col flex-grow gap-2'>
          <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
          <SelectableList 
            items={parameters.map(element => element.alias ? element.alias : element.key)} 
            multiSelect={true} 
            setItems={selectColums}
            selection={conf.headers.map(element => element.alias ? element.alias : element.key)}
            />
        </div>
        
        {/* Span fijo al final del contenedor */}
        <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
          <div className='flex w-full justify-end'>
              < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
     )}
    </>
   
    
  );
}

export default RegistersTableForm;
